import React from "react";
import { SubmitHandler } from "react-hook-form";
import CreateBannerForm from "src/features/vendorSponsorshipAdmin/components/CreateBannerForm/CreateBannerForm";
import VENDOR_PROMOTION_FORM from "../../constants/vendorStepsForm";
import CustomToast from "src/components/CustomToast/CustomToast";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useCreatePromotion from "../../hooks/useCreatePromotion";
import adaptCreateBanner from "src/features/HomepageCarouselBanners/adapters/adaptCreateBanner";

const CreatePromotion = () => {
	const navigate = useNavigate();

	const defaultValues: BannerFormState = {
		bannerStyle: "standard",
		bannerType: "promotionImage",
		selectedHashtag: null,
		feedId: null,
		steps: VENDOR_PROMOTION_FORM,
		audienceGroupIds: [],
		buttonLink: "",
		openInBrowser: false,
		linkFeedId: null,
		selectedLinkFeed: null
	};

	const { mutate: createPromotionBanner } = useCreatePromotion();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Saved Successfully" />);
		navigate("/vendor-sponsorship/promotion/banners?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error creating the form" />
		);
	};

	const onSubmit: SubmitHandler<BannerFormState> = (data) => {
		console.log("FORM IS VALID, SUBMIT FORM", data);

		createPromotionBanner(adaptCreateBanner(data), {
			onSuccess,
			onError
		});
	};

	return (
		<CreateBannerForm
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			bannerTypeRadioOptions={["promotionImage", "promotionVideo"]}
			showVariantTab={false}
			showAudienceGroups
			root="promotion"
		/>
	);
};

export default CreatePromotion;
